<template>    
  <div
    v-show="!cookieMsg"
    class="bg-opacity-9 fixed z-30 inset-x-0 h-auto px-6 py-3 shadow-xl bottom-0 bg-white w-full md:w-11/12 lg:w-7/12 mx-auto mb-0 md:mb-6"
  >
    <div
      class="flex flex-col md:flex-row justify-between text-primary items-center"
    >
      <p class="texto-roboto mr-5">
        We use cookies to give you the best possible user experience. If you
        continue to use our website or services, we will consider you accepting
        its use.
        <router-link to="/privacy" class="font-bold">
          View our Privacy Policy
        </router-link>
      </p>
      <button
        @click="setCookies"
        class="mx-auto mt-4 md:mx-0 md:mt-0 w-48 border border-solid border-primary rounded-full h-10 font-bold focus:outline-none"
      >
        Accept
      </button>
    </div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies'

export default {
  name: "CookieWarn",
  data() {
    return {
      cookieMsg: false
    };
  },
  created() {
    this.cookieMsg = VueCookies.get('user_session')
  },
  methods: {
    setCookies: function() {
      VueCookies.set('user_session', true)
      this.cookieMsg = true
    }
  },
};
</script>

<style scoped>
button {
  min-width: 174px;
  height: 42px;
  padding-left: 1rem;
  padding-right: 1rem;
}

button:hover {
  background-color: #efffec;
}
</style>
